import PropTypes from 'prop-types';

import { Grid } from '@mui/material';

import ModalHandlerContainer from '../Modal/ModalHandlerContainer';

import LoadingComponent from '../LoadingSpinner/LoadingSpinnerComponent';

import useRemoveTrailingSlash from '../../hooks/useRemoveTrailingSlash';
import DisplaySizeDetector from '../DisplaySizeDetector';
import ErrorBoundary from './ErrorBoundary';

const LayoutComponent = ({ children }) => {
  useRemoveTrailingSlash();

  return (
    <ErrorBoundary>
      <Grid container id="screen_area" sx={{ height: '100%' }}>
        <DisplaySizeDetector />
        <ModalHandlerContainer />
        <LoadingComponent />
        {children}
      </Grid>
    </ErrorBoundary>
  );
};

LayoutComponent.propTypes = {
  children: PropTypes.instanceOf(Object),
};

export default LayoutComponent;
